<template>
    <b-card :title="title">

        <template slot="body">

            <div class="card-map" :style="heightStyle">
                <div :id="options.mapId" class="h-100"></div>
            </div>

            <div class="card-body">
                <div :id="options.controls.id" v-if="options.controls.enable" >
                    <!-- Block for buttons and other stuff -->
                </div>

                <slot name="body" v-if="hasBodyContent"></slot>
            </div>

        </template>
    </b-card>
</template>

<script>
import OptionalSlots from '../mixins/OptionalSlotsMixin';
import createMap from '../../src/maps/createMap';
import mapUtils from '../../src/maps/utils';

export default {
    mixins: [OptionalSlots],

    props: {

        title: {
            type: String,
            default: 'Map',
        },

        config: {
            type: Object,
            default: () => {},
        },

        location: {
            type: Object,
            default: null,
        }

    },

    data() {
        return {
            defaultConfig: {
                mapId: 'map',
                controls: {
                    enable: false,
                    id: 'map-controls',
                },
                height: '320px',
                layers: [],
            },
            map: null,
        };
    },

    computed: {

        options() {
            return {
                ...this.defaultConfig,
                ...this.config,
            };
        },

        heightStyle() {
            return {
                height: this.options.height,
            };
        }

    },

    mounted() {
        this.map = createMap({
            target: this.options.mapId,
            layers: this.options.layers,
        });

        this.showLocation();
    },

    methods: {

        /* Shows only single (general or not) entity/administrative-unit polygon or point */
        showLocation() {
            if (this.location)
            {
                if (this.location.coords) {
                    mapUtils.addPin(this.map, this.location);
                } else {
                    mapUtils.addGeoJson(this.map, this.location);
                }
            }
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/maps/MapCard.vue